module.exports = __webpack_public_path__ + "img/res2.af3dd263.png";